
import {
    defineComponent, PropType,
} from '@vue/composition-api';

export default defineComponent({
    name: 'railway-tours-tab',
    props: {
        isActive: {
            type: Boolean as PropType<boolean>,
        },
    },
});
